var map = {
	"./aed.png": 897,
	"./aud.png": 898,
	"./bgn.png": 899,
	"./bhd.png": 900,
	"./cad.png": 901,
	"./chf.png": 902,
	"./cnh.png": 903,
	"./cny.png": 904,
	"./czk.png": 905,
	"./dkk.png": 906,
	"./eur.png": 907,
	"./gbp.png": 908,
	"./hkd.png": 909,
	"./hrk.png": 910,
	"./huf.png": 911,
	"./idr.png": 912,
	"./ils.png": 913,
	"./inr.png": 914,
	"./jpy.png": 915,
	"./kes.png": 916,
	"./kwd.png": 917,
	"./mxn.png": 918,
	"./myr.png": 919,
	"./nok.png": 920,
	"./nzd.png": 921,
	"./omr.png": 922,
	"./php.png": 923,
	"./pln.png": 924,
	"./qar.png": 925,
	"./ron.png": 926,
	"./rub.png": 927,
	"./sar.png": 928,
	"./sek.png": 929,
	"./sgd.png": 930,
	"./thb.png": 931,
	"./try.png": 932,
	"./ugx.png": 933,
	"./usd.png": 934,
	"./zar.png": 935
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 896;